import React, { useState } from 'react';
import { RES_PATH } from '@common/config';
import classnames from 'classnames';
var SvgImage = function (props) {
    var iconUrl = props.iconUrl, prefixCls = props.prefixCls;
    var _a = useState(RES_PATH + 'sources/svg/sc_default.svg'), tempUrl = _a[0], setTempUrl = _a[1];
    var _b = useState(false), isFlag = _b[0], setIsFlag = _b[1];
    var handleOnload = function () {
        if (isFlag) {
            return false;
        }
        var imgDom = new Image();
        imgDom.src = iconUrl;
        imgDom.onload = function () {
            setIsFlag(true);
            setTempUrl(iconUrl);
        };
    };
    return React.createElement('div', { className: classnames('sc-icon', prefixCls) }, React.createElement('img', {
        className: classnames('sc-icon', prefixCls),
        src: tempUrl,
        onLoad: handleOnload
    }));
};
export default SvgImage;